module.exports = __webpack_public_path__ + "static/dia-site-1c1f72fc76fdff9c7394dcb6606a9553.jpg";